import React, {useState, useEffect, useRef} from 'react'

import classes from './PopupMinigameIntro.module.css'
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import {CountUp} from 'countup.js';
import clsx from 'clsx';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Minigame from '@/js/Minigames/Minigame';
import Star from '@/components/shared/Star/Star';
import ActivityTitle from '../PopupMinigameSequence/ActivityTitle/ActivityTitle';
import ActivityLogoName from '@/components/shared/ActivityLogoName/ActivityLogoName';


const PopupMinigameIntro = () => {


  /** @type {Minigame} */
  let mg = PopupsManager.getData(POPUPS.MINIGAME_INTRO)
  const icon = mg?.icon
  const descr = mg.description

  function handleClick() {
    PopupsManager.close(POPUPS.MINIGAME_INTRO)
  }

  return (
    <Popup >

      <div className={classes.PopupMinigameIntro}>
        <div className={classes.Activity}>

          <ActivityLogoName mg={mg} showDescr />

        <div className={classes.btns_ctnr}>
          <Button onClick={handleClick} >Continuer</Button>
        </div>

      </div>
    </div>
    </Popup>
  );
};

export default PopupMinigameIntro;
